import React, {Component} from 'react';
import Form from './form';
import ReferenceWorkflowAI from './reference_workflow_ai';
import Markdown from './markdown';
import request from '../request';

export default class ReferenceShow extends Component {
  constructor(props) {
    super(props);
    this.state = {show_summary: false};
    this.toggleAbstract = this.toggleAbstract.bind(this);
    this.toggleWorkflowData = this.toggleWorkflowData.bind(this);
  }

  toggleAbstract() {
    let show_abstract = !this.state.show_abstract;
    this.setState({show_abstract});
  }

  toggleWorkflowData() {
    let show_workflow_data = !this.state.show_workflow_data;
    this.setState({show_workflow_data});
  }

  renderNoAbstractText() {
    return (
      <div>
        This reference has no abstract text.
      </div>
    )
  }

  renderAbstract() {
    let {show_abstract} = this.state;
    if (!show_abstract) return null;
    let {reference} = this.props;
    return (
      <div>
        <Markdown text={reference.abstract_text} />
      </div>
    )
  }

  renderWorkflowData() {
    let {show_workflow_data} = this.state;
    if (!show_workflow_data) return null;
    let {reference} = this.props;
    return <ReferenceWorkflowAI reference_id={reference.id} />
  }

  renderDataButtons() {
    let {reference} = this.props;
    if (!reference.abstract_text) return this.renderNoAbstractText();
    let {show_abstract, show_workflow_data} = this.state;
    let workflow_btn_label = show_workflow_data ? ' Hide Workflow Data' : 'Show Workflow Data';
    let abstract_btn_label = show_abstract ? 'Hide Abstract' : 'Show Abstract';

    return (
      <div>
        <button className="btn btn-success ref-panel-btn" onClick={this.toggleAbstract}>{abstract_btn_label}</button>
        {this.renderAbstract()}

        <button className="btn btn-success ref-panel-btn" onClick={this.toggleWorkflowData}>{workflow_btn_label}</button>
        {this.renderWorkflowData()}
      </div>
    )
  }

  render() {
    let {reference} = this.props;
    return(
      <div className="row">
        <div className="col-md-9">
          {this.renderDataButtons()}
        </div>
      </div>
    )
  }
}
